import clsx from 'clsx'
import isEmpty from 'lodash/isEmpty'
import React from 'react'

import { BlockContainer } from '@Components/BlockContainer'
import { Title } from '@Components/CMS/Title'
import { ProductSlider as ProductSliderV2 } from '@Domains/Product/Features/ProductSlider/ProductSlider'
import { PagePresentation, ProductSliderBlock as ProductSliderBlockGraphQL } from '@Generated/graphql'
import { BlockContext, useBlockConfig } from '@Globals/CMS/Context'

import styles from './ProductSliderBlock.module.scss'

const ProductSliderBlock = ({
  data,
  id,
}: {
  data: ProductSliderBlockGraphQL
  id?: string
}) => {
  const { presentation } = React.use(BlockContext)
  const config = useBlockConfig()
  const products = (data?.slider?.__typename === 'ProductSlider' ? data?.slider?.products : config?.algolia?.hitsArray) || []

  if (data.appearance && data.common && !isEmpty(data.common.title)) {
    const { appearance, common } = data
    return (
      <BlockContainer
        appearance={appearance || {}}
        common={common || {}}
        id={id}
      >
        <ProductSliderV2
          className={styles.slider}
          hideBuyButtons={false}
          products={products}
          skipReset
          style={{ thumbColor: appearance?.textColor || undefined }}
          withoutSuccessPrompt={presentation === PagePresentation.Sidebar}
        />
      </BlockContainer>
    )
  }

  return (
    <ProductSliderV2
      className={clsx(styles.productSlider)}
      header={<Title title={data.header || ''} type="h4" />}
      hideBuyButtons={false}
      id={id}
      products={products}
      skipReset
      withoutSuccessPrompt={false}
    />
  )
}

export default ProductSliderBlock
